import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import { ReportsCollection } from "../../../collections/Reports";
import { TimezoneCollection } from "../../../collections/Timezones";
import { Utils } from "../../../common/utils";
import { BaseList, TableProperties } from "../../_BaseList";
import { GenericDeleteModal } from "../../modals/GenericDeleteModal";
import { ModifyReportModal } from "../../modals/reports/ModifyReportModal";
import { BaseAccountListView, BaseAccountViewOptions } from "../_BaseAccountViews";
import { ReportOverviewView } from "./ReportOverviewView";

export class ReportAccountView extends BaseAccountListView {

    private organizationReportsCollection: ReportsCollection = null;

    constructor(options: BaseAccountViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-report': 'handleAddReportClick',
                'click .delete-from-list': 'deleteReport',
            }
        }));
    }

    show(orgId, reportId?, detail?, subDetail?) {
        if (this.options.permissionCollection.canViewOrganization(this.options.currentOrganizationId)) {
            var reports = this.options.reportsCollection.filter((report) => {
                return report.get('organization_id') === this.options.currentOrganizationId;
            });

            this.organizationReportsCollection = new ReportsCollection(reports);
        }

        if (reportId) {
            var view = new ReportOverviewView(_.extend({}, this.options, {
                organizationReportsCollection: this.organizationReportsCollection
            }));

            this.$el.empty().append(view.render().$el);
            view.show(reportId, detail, subDetail);
            this.subViews.push(view);
            return;
        }

        this.collectionLoaded = true;
        this.render();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
    }

    render() {
        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            currentOrganizationId: this.options.currentOrganizationId,
            collectionLoaded: this.collectionLoaded,
            urlAddon: '/reports'
        }));

        var canAddReport = this.options.permissionCollection.canCreateNewReport(this.options.currentOrganizationId);
        this.$('.container').append(this.panelTemplate({
            panelTitle: {text: 'Reports', url: null},
            panelClass: 'reports',
            panelWidth: '',
            headerLink: null,
            addButton: {canAdd: canAddReport, label: "Add Report", 'class': "add-report"},
            search: true,
            collectionLoaded: this.collectionLoaded,
            footer: null
        }));

        this.showBreadcrumbs();
        if (this.collectionLoaded) this.showTable();
        this.delegateEvents();
        return this;
    }

    showTable() {
        var getReportModifiedDate = function (report, widCols) {
            var dates = [moment(report.get('modified')).format("L")];
            var widgetDate = 0;
            widCols[report.get('id')].each((widget) => {
                if (widget.get('modified') > widgetDate) widgetDate = widget.get('modified')
            });

            if (widgetDate !== 0) dates.push(moment.unix(widgetDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();
            return _.first(dates);
        };

        var timezones = new TimezoneCollection();
        var reportTable = new BaseList(this.options);
        var reportTableProperties: TableProperties = {
            canDeletePermissionFunction: this.options.permissionCollection.canDeleteReport.bind(this.options.permissionCollection),
            canDeletePermissionFunctionAttribute: 'id',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/reports/',
            tableEmptyText: 'There are no Reports',
            columnProperties: {
                'Report Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Format': {
                    attribute: 'format',
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Recipients': {
                    attribute: 'recipient',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Interval': {
                    attribute: 'interval',
                    customColumn: {
                        templateFunction: _.template('' +
                            '<% var utc = timezones.findWhere({momentjs: mod.get("timezone")}).get("utcOffset"); %> ' +
                            '<% var s = getIntervalString(mod.get("interval"), mod.get("offset_seconds"), mod.get("offset_days"), mod.get("offset_months"), utc); %> ' +
                            '<div class="col-sm-2 col-md-2 col-xs-12" data-table-cell="<%- s %>"><%- s %></div>'
                        ),
                        variables: {
                            getIntervalString: Utils.Time.getIntervalString,
                            timezones
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                }
            }
        };

        this.$('.reports .panel-body > .row').append(reportTable.renderCollectionList(this.organizationReportsCollection, reportTableProperties).$el);
    }

    showBreadcrumbs() {
        super.showBreadcrumbs('Reports', 'Categories');
    }

    handleAddReportClick() {
        var view = new ModifyReportModal(_.extend({}, this.options, {
            isClone: false,
            reportsCollection: this.organizationReportsCollection,
            orgId: this.options.currentOrganizationId,
            reportId: null,
            modelId: null
        }));
        $('.modals').append(view.render().el);
        view.show();
    }

    deleteReport(e) {
        e.stopPropagation();

        var id = Number($(e.currentTarget).attr('data-model-id'));
        var report = this.organizationReportsCollection.findWhere({id: id});

        var modal = new GenericDeleteModal({
            type: 'Report',
            name: report.get('name'),
            func: () => {
                return $.when(report.destroy()).done(() => {
                    Backbone.history.loadUrl();
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/reports/ReportAccountView.ts